import React from 'react';

const AuxiliaryWaves = ({ className }) => {
  return (
    <svg
      className={className}
      width="1440"
      height="400"
      viewBox="0 0 1440 400"
      preserveAspectRatio="none"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.39"
        d="M586.482 252.5C320.144 490.1 84.5199 306.833 0 185.5V400H1440V69C1383.1 154 1246.64 296.3 1155.99 185.5C1065.35 74.7 738.551 184 586.482 252.5Z"
        fill="#DDCAEB"
      />
      <path
        opacity="0.39"
        d="M586.482 244.044C320.144 488.822 84.5199 300.019 0 175.02V396H1440V55C1383.1 142.568 1246.64 289.167 1155.99 175.02C1065.35 60.8722 738.551 173.474 586.482 244.044Z"
        fill="#DDCAEB"
      />
      <path
        opacity="0.39"
        d="M586.482 221.752C320.144 508.882 84.5199 274.126 0 127.5V400H1440V0C1383.1 102.719 1246.64 274.683 1155.99 140.785C1065.35 6.88818 738.551 138.973 586.482 221.752Z"
        fill="#DDCAEB"
      />
      <path
        opacity="0.57"
        d="M586.482 231.556C320.144 502.894 84.5199 293.604 0 155.042V400H1440V22C1383.1 119.069 1246.64 281.575 1155.99 155.042C1065.35 28.5093 738.551 153.329 586.482 231.556Z"
        fill="#DDCAEB"
      />
    </svg>
  );
};

export default AuxiliaryWaves;